module.exports = __webpack_public_path__ + "img/3.c31f5d1d.png";